import apiInputService from "services/apiInputService";
import { useQuery } from "@tanstack/react-query";

const fetch = async (): Promise<ITicketPickList> => {
  const { data } = await apiInputService.get(`/ticket/picklist/priority`);

  return data as ITicketPickList;
};

export const useGetTicketPickList = (options?: any) =>
  useQuery(["ticket-pick-list"], () => fetch(), {
    ...options,
    staleTime: Infinity,
  });
